import type { ItemStatus, LimitedPortion, UnableReason } from '../../domain/inspection';
import { useT } from '../../i18n/i18n';
import { resultLabel } from '../../i18n/labels';
import type { ItemResultConfirmations } from '../../state/inspectionStore';
import { ConfirmSheet } from '../../ui/components';

// NY F1 R3 narrow repair (F-R3-04): the ONE confirmation for a whole-row result that cannot carry the
// recorded parts not observed (N/A, and any way to Unable that did not pass through the quick reason
// sheet's own notice), shared by the checklist card and the item workspace, on the same destructive-
// transition pattern as DefectRemovalConfirm (Round 2 §V): the record is untouched until the inspector
// continues; Cancel closes without side effects; Continue removes the incompatible parts together with
// the new result — deliberately, never silently, never leaving them behind.
export interface PortionRemovalRequest {
  status: ItemStatus;
  unable?: { reasonCode: UnableReason; note: string };
  portions: LimitedPortion[];
  // The confirmations already given for this same transition (the defect-removal answer), so that one
  // Continue does not re-ask them.
  confirmed: ItemResultConfirmations;
}

export function PortionRemovalConfirm(props: { request: PortionRemovalRequest; onConfirm: () => void; onCancel: () => void }) {
  const { t, tp } = useT();
  const result = resultLabel(t, props.request.status);
  return (
    <ConfirmSheet
      title={t('item.portionRemoveTitle')}
      body={tp('item.portionRemoveBody', props.request.portions.length, { result })}
      confirmLabel={t('item.portionRemoveConfirm', { result })}
      danger
      onConfirm={props.onConfirm}
      onCancel={props.onCancel}
      testId="portion-removal-confirm"
    />
  );
}
